import React, { useEffect } from "react";
import MainLayout from "../../layout";
import { TextView } from "../../components/view-form-components/text-view";
import {
  DocumentView,
  ImageView,
} from "../../components/view-form-components/image.view";
import ResetPasswordModal from "../../components/modal/reset-password-modal";
import { useState } from "react";
import axios from "axios";
import { url, web_url } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../components/modal/delete-modal";
import SwitchView from "../../components/view-form-components/switch-view";
import backArrow from "../../assets/icons/back-arrow.svg";
import FAQManager from "../../components/editor/components/FAQManager";
import Editor from "../../components/editor";
import { FormToggleSwitch, ToggleSwitch } from "../../components/form/checkbox";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import PreviewModal from "../../components/modal/blog-preview-modal";

const ReadBlogs = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [published, setPublished] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const previewUrl = `${web_url}/blogs/preview/${data?.slug}`;

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/model/blogs/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        setPublished(res.data.data.published);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/blogs/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/admin/users/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const handlePublishToggle = (checked) => {
    setPublished(checked);

    const payload = {
      where: {
        id: params?.id,
      },
      values: {
        category_id: data?.category_id ?? "",
        title: data?.title ?? "",
        description: data?.description ?? "",
        meta_title: data?.meta_title ?? "",
        meta_description: data?.meta_description ?? "",
        landscape_card_image_1: data?.landscape_card_image_1 ?? "",
        landscape_card_image_1_alt_text:
          data?.landscape_card_image_1_alt_text ?? "",
        landscape_card_image_2: data?.landscape_card_image_2 ?? "",
        landscape_card_image_2_alt_text:
          data?.landscape_card_image_2_alt_text ?? "",
        portrait_card_image: data?.portrait_card_image ?? "",
        portrait_card_image_alt_text: data?.portrait_card_image_alt_text ?? "",
        blogs_details_image: data?.blogs_details_image ?? "",
        blogs_details_image_alt_text: data?.blogs_details_image_alt_text ?? "",
        author: data?.author ?? "",
        slug: data?.slug ?? "",
        published: checked,
      },
    };

    axios
      .post(`${url}/model/blogs/edit`, payload)
      .then((response) => {
        successToast(response.data.message);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
        setPublished((prev) => !prev); // rollback on failure
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <PreviewModal
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        url={previewUrl}
      />

      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <div className="flex items-center gap-2">
            <button onClick={() => navigate(-1)} type="button">
              <img src={backArrow} alt="<" width={10} height={10} />
            </button>
            <h2 className="text-xl font-semibold capitalize">Blogs - view</h2>
          </div>
          <div className="flex items-center gap-5">
            <button
              onClick={() => {
                setPreviewOpen(true);
              }}
              className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
            >
              Preview
            </button>{" "}
            <ToggleSwitch
              label="published"
              value={published}
              onChange={handlePublishToggle}
              disable={data?.status === "draft" || data?.status === "submitted"}
            />
            <button
              onClick={() => navigate(`/blogs/edit/${params?.id}`)}
              className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
            >
              Edit
            </button>
            <button
              onClick={() => {
                setdeleteModalShow(true);
              }}
              className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
            >
              Delete
            </button>{" "}
          </div>
        </div>

        <section className="w-full max-w-[40rem]">
          <TextView label={"title"} value={data?.title} />{" "}
          <TextView label={"description"} value={data?.description} />
          <TextView label={"meta title"} value={data?.meta_title} />
          <TextView
            label={"meta description"}
            value={data?.meta_description ?? "--"}
          />
          <DocumentView
            label={"landscape card image 1"}
            value={data?.landscape_card_image_1 ?? "--"}
          />{" "}
          <TextView
            label={"landscape card image 1 alt text"}
            value={data?.landscape_card_image_1_alt_text ?? "--"}
          />
          <DocumentView
            label={"landscape card image 2"}
            value={data?.landscape_card_image_2 ?? "--"}
          />{" "}
          <TextView
            label={"landscape card image 2 alt text"}
            value={data?.landscape_card_image_2_alt_text ?? "--"}
          />
          <DocumentView
            label={"portrait card image"}
            value={data?.portrait_card_image ?? "--"}
          />{" "}
          <TextView
            label={"portrait card image alt text"}
            value={data?.portrait_card_image_alt_text ?? "--"}
          />
          <DocumentView
            label={"blogs details image"}
            value={data?.blogs_details_image ?? "--"}
          />{" "}
          <TextView
            label={"blogs details image alt text"}
            value={data?.blogs_details_image_alt_text ?? "--"}
          />
          <TextView label={"author"} value={data?.author ?? "--"} />
          <TextView label={"slug"} value={data?.slug ?? "--"} />
          <TextView label={"Read time"} value={data?.read_time ?? "--"} />
        </section>
        <div className="w-full overflow-y-auto pointer-events-none">
          <Editor
            contentData={
              data?.content_section?.length > 0 ? data?.content_section : []
            }
            setContentData={() => {}}
            read={true}
          />
        </div>
        <div className="w-full overflow-y-auto pointer-events-none">
          <FAQManager
            faqs={data?.faq?.length > 0 ? data?.faq : []}
            read={true}
          />
        </div>
      </section>
    </MainLayout>
  );
};

export default ReadBlogs;
